
export default {
  name: "LogoGym"
}
